import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography, Autocomplete } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const TherapyRoomMaster = () => {
    const [formState, setFormState] = useState({
        roomCode: "",
        roomName: "",
        facilities: [],
        amenities: [],
        treatments: []
    });
    const [isActive, setIsActive] = useState(true);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    });
    const [TherapyRoomData, setTherapyRoomData] = useState([]);
    const [FacilityList, setFacilityList] = useState([]);
    const [AmenityList, setAmenityList] = useState([]);
    const [TreatmentList, setTreatmentList] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Therapy Room Master", "SubTab")?.editAccess

    useEffect(() => {
        getTherapyRoomMaster();
        getFacilitiesList();
        getAmenitiesList();
        getTreatmentsList();
    }, []);

    const getTherapyRoomMaster = () => {
        setisloader(true)
        RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPY_ROOM_MASTER)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyRoomData(response?.data?.data || [])
                }
                setisloader(false)
            }).catch(e => {
                setisloader(false)
                errorMessage(e?.response?.data?.message || e.message)
            })
    }

    const getFacilitiesList = () => {
        RestAPIService.getAll(Serviceurls.AYURVEDA_FACILITIES_MASTER)
            .then((response) => {
                if (response.data.status === 'success') {
                    setFacilityList(response?.data?.data || [])
                }
            }).catch(e => errorMessage(e?.response?.data?.message || e.message))
    }

    const getAmenitiesList = () => {
        RestAPIService.getAll(Serviceurls.AYURVEDA_AMENITIES_MASTER)
            .then((response) => {
                if (response.data.status === 'success') {
                    setAmenityList(response?.data?.data || [])
                }
            }).catch(e => errorMessage(e?.response?.data?.message || e.message))
    }

    const getTreatmentsList = () => {
        RestAPIService.getAll(Serviceurls.AYURVEDA_TREATMENT_MASTER)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTreatmentList(response?.data?.data || [])
                }
            }).catch(e => errorMessage(e?.response?.data?.message || e.message))
    }

    const AddTherapyRoom = () => {
        if (!formState?.roomName) {
            return errorMessage('Please Enter Therapy Room Name');
        }
        if (formState?.facilities?.length === 0) {
            return errorMessage('Please Select Facilities');
        }
        if (formState?.amenities?.length === 0) {
            return errorMessage('Please Select Amenities');
        }
        if (formState?.treatments?.length === 0) {
            return errorMessage('Please Select Treatments');
        }

        let data = {
            room_name: formState?.roomName,
            facilities: formState?.facilities.map(f => f.id),
            amenities: formState?.amenities.map(a => a.id),
            treatments: formState?.treatments.map(t => t.id),
            is_active: isActive,
        }

        setisloader(true)
        let apiCall;
        if (EditID) {
            apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_THERAPY_ROOM_MASTER);
        } else {
            apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_THERAPY_ROOM_MASTER);
        }
        apiCall
            .then((response) => {
                if (response.data.status === 'success') {
                    successMessage(response.data.message)
                    setFormState({
                        roomCode: "",
                        roomName: "",
                        facilities: [],
                        amenities: [],
                        treatments: []
                    });
                    setIsActive(true)
                    setEditID(null)
                    getTherapyRoomMaster()
                }
                setisloader(false)
            }).catch(e => {
                setisloader(false)
                errorMessage(e?.response?.data?.message || e.message)
            })
    }

    const deleteTherapyRoom = () => {
        let ID = deletedID ? [deletedID] : (delIDs || [])
        RestAPIService.delete(Serviceurls.AYURVEDA_THERAPY_ROOM_MASTER + `?ids=${ID}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    successMessage(response.data.message)
                    getTherapyRoomMaster()
                    setdelIDs([]);
                    setCheckBoxList([]);
                    setdeletedID(null);
                    setisDelete(false)
                }
            }).catch(e => {
                errorMessage(e?.response?.data?.message || e.message)
            })
    }

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        })
    }

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const tableView = () => {
        const grpDelete = () => setisDelete(true)

        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
            </Box>
        )

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = TherapyRoomData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        TherapyRoomData?.forEach((element, index) => element.sno = index + 1)

        const columns = [
            {
                field: "sno",
                headerName: "S.No",
                flex: 0.05,
                sortable: false,
                renderCell: (params) => (
                    <Typography fontSize={"0.9vw"}>
                        {params.row.sno}
                    </Typography>
                ),
            },
            { field: "room_code", headerName: "Therapy Room Code", flex: 0.2 },
            { field: "room_name", headerName: "Therapy Room Name/No", flex: 0.3 },

            {
                field: "facilities",
                headerName: "Facilities",
                flex: 0.25,
                renderCell: (params) => {
                    let names = (params.row.facilities || []).map((f) => f.facilities_name);
                    return names.length > 2 ? (
                        <Tooltip title={names.join(", ")}>
                            <Typography fontSize={"0.9vw"}>
                                {names.slice(0, 2).join(", ")}...
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={"0.9vw"}>{names.join(", ") || "-"}</Typography>
                    );
                },
            },
            {
                field: "amenities",
                headerName: "Amenities",
                flex: 0.25,
                renderCell: (params) => {
                    let names = (params.row.amenities || []).map((a) => a.amenities_name);
                    return names.length > 2 ? (
                        <Tooltip title={names.join(", ")}>
                            <Typography fontSize={"0.9vw"}>
                                {names.slice(0, 2).join(", ")}...
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={"0.9vw"}>{names.join(", ") || "-"}</Typography>
                    );
                },
            },

            {
                field: "treatments",
                headerName: "Therapy Name",
                flex: 0.25,
                renderCell: (params) => {
                    let names = (params.row.treatments || []).map((t) => t.treatment_name);
                    return names.length > 2 ? (
                        <Tooltip title={names.join(", ")}>
                            <Typography fontSize={"0.9vw"}>
                                {names.slice(0, 2).join(", ")}...
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={"0.9vw"}>{names.join(", ") || "-"}</Typography>
                    );
                },
            },

            {
                field: "is_active",
                headerName: "Status",
                flex: 0.1,
                renderCell: (params) => (
                    <Box>{params?.row?.is_active ? "Active" : "Inactive"}</Box>
                ),
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <CommonEditButton size="1.5vw" onClick={() => {
                            setFormState({
                                roomCode: params?.row?.room_code,
                                roomName: params?.row?.room_name,
                                facilities: params?.row?.facilities || [],
                                amenities: params?.row?.amenities || [],
                                treatments: params?.row?.treatments || [],
                            });
                            setEditID(params.row.id);
                            setIsActive(params.row.is_active);
                        }} />
                    </Stack>)
            }] : [])
        ]

        return (
            <Box sx={{ height: '59vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={TherapyRoomData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    components={{ Toolbar: gridToolBar }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                />
            </Box>
        )
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ height: '20vh', width: '93vw', backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: "wrap" }}>
                    <TextField
                        size="small"
                        name="roomCode"
                        value={formState?.roomCode}
                        disabled
                        sx={{ width: "15vw", marginRight: "1vw" }}
                        label="Therapy Room Code"
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="roomName"
                        value={formState?.roomName}
                        sx={{ width: "20vw", marginRight: "1vw" }}
                        label="Therapy Room Name/No *"
                        variant="outlined"
                        inputProps={{ maxlength: 25 }}
                        onChange={(e) => setFormState({ ...formState, roomName: e.target.value })}
                    />
                    <Autocomplete
                        multiple
                        size="small"
                        limitTags={1}
                        options={FacilityList}
                        getOptionLabel={(option) => option?.facilities_name || ""}
                        value={formState?.facilities}
                        onChange={(event, newValue) => {
                            setFormState({ ...formState, facilities: newValue })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Facilities *"
                                size="small"
                                sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        flexWrap: "nowrap",   // ✅ stop height expansion
                                        overflow: "hidden"
                                    }
                                }}
                            />
                        )}
                        sx={{
                            width: "20vw",
                            marginRight: "1vw",
                            "& .MuiAutocomplete-tag": {
                                maxWidth: "70px"         // optional – prevents long chip stretch
                            }
                        }}
                    />
                    <Autocomplete
                        multiple
                        size="small"
                        limitTags={1}
                        options={AmenityList}
                        getOptionLabel={(option) => option?.amenities_name || ""}
                        value={formState?.amenities}
                        onChange={(event, newValue) => {
                            setFormState({ ...formState, amenities: newValue })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Amenities *"
                                size="small"
                                sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        flexWrap: "nowrap",   // ✅ stop height expansion
                                        overflow: "hidden"
                                    }
                                }}
                            />
                        )}
                        sx={{
                            width: "20vw",
                            marginRight: "1vw",
                            "& .MuiAutocomplete-tag": {
                                maxWidth: "70px"         // optional – prevents long chip stretch
                            }
                        }}
                    />
                    <Autocomplete
                        multiple
                        size="small"
                        limitTags={1}
                        options={TreatmentList}
                        getOptionLabel={(option) => option?.treatment_name || ""}
                        value={formState?.treatments}
                        onChange={(event, newValue) => {
                            setFormState({ ...formState, treatments: newValue })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Treatments *"
                                size="small"
                                sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        flexWrap: "nowrap",   // ✅ stop height expansion
                                        overflow: "hidden"
                                    }
                                }}
                            />
                        )}
                        sx={{
                            width: "20vw",
                            marginRight: "1vw",
                            marginTop: "1vw",
                            "& .MuiAutocomplete-tag": {
                                maxWidth: "70px"         // optional – prevents long chip stretch
                            }
                        }}
                    />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} size="small" />} label="Active" />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                        <Button size="small" variant="outlined" sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            onClick={() => {
                                setFormState({ roomCode: "", roomName: "", facilities: [], amenities: [], treatments: [] });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => AddTherapyRoom()}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ height: '58vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>

            {message.isErrorMsg &&
                <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />
            }
            {message.successMsg &&
                <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />
            }
            {isDelete &&
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this item?"
                    DeleteNotify="This action cannot be undone."
                    deleteAlertPopupClose={() => setisDelete(false)}
                    removeData={deleteTherapyRoom}
                    ButtonText="Yes"
                />
            }
            <Loader loaderOpen={isloader} />
        </Box>
    )
}

export default TherapyRoomMaster;
